import type { RenderSegment } from '../../ProjectPage/components/ProjectSegment/ProjectSegment.types'
import { QUICK_NOTES_SECTION_IDS } from '../hooks/useQuickNotesSegments'

/**
 * Wohin eine neue Notiz ohne gezielten Platz in Kurz notiert kommt — „Neue
 * Aufgabe" der **Listen-Werkzeug-Pille**, ⌘N und Menü ohne Fokus: immer nach
 * „Letzte 7 Tage", **oben** — die neueste zuerst (#247, bis 03.10.2026 unten).
 * Die Regeln aus dem Projekt (`listToolbarTarget.ts`) trafen mit „sonst ganz
 * unten" den Eimer „Älter": Der Ersteller stand unter allen alten Notizen, und
 * nach Enter sprang die Notiz nach oben.
 *
 * Gibt es „Letzte 7 Tage" noch nicht (alle Notizen älter), entsteht der Eimer
 * mit der neuen Notiz ÜBER „Älter" — der Ersteller steht darum oben in „Älter",
 * direkt unter dessen Kopf, und das auch eingeklappt.
 */
export function quickNotesNewTaskTarget(segments: RenderSegment[]): {
  position: 'top' | 'bottom'
  segmentIndex: number
  expandSectionId: string | null
} {
  const recentIndex = segments.findIndex(segment => segment.section?.id === QUICK_NOTES_SECTION_IDS.recent)
  if (recentIndex === -1) return { position: 'top', segmentIndex: 0, expandSectionId: null }
  return {
    position: 'top',
    segmentIndex: recentIndex,
    expandSectionId: segments[recentIndex].collapsed ? QUICK_NOTES_SECTION_IDS.recent : null,
  }
}
